import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalWarningNoticeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/WarningNotice/WarningNoticeBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalWarningNotice"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalWarningNotice"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalWarningNoticeActivity)
